import { Provider, atom, useAtom } from 'jotai'
import { useReducerAtom } from 'jotai/utils'
import state from 'Project/Collection/traits.json'
import { SORT } from 'const/sort';
const initialReducerState = { selected: { background: [], pattern: [], weapon: [], tail: [], clothing: [], shoulder: [], ears: [], head: [], eyebrows: [], eyes: [], mouth: [], facial: [], hat: [] }, state, stack: [], sortMethod: SORT.lastMint }

export const filterJotai = atom(false)
export const queryJotai = atom(JSON.stringify(state.selected))
export const reducerJotai = atom(initialReducerState)
export const sortMethodJotai = atom(1)